import { useCallback } from 'react'
import { SketchElement } from '../types'
import { useZoomToFitNode } from '@sketch-hq/sketch-web-renderer'

/**
 * Changes the canvas pan and zoom to center the given layer in the canvas viewport.
 */
export function useGoToLayer() {
  const zoomToFitLayer = useZoomToFitNode()

  return useCallback(
    (sketchElement: SketchElement) => {
      zoomToFitLayer(sketchElement.identifier, 0.6)
    },
    [zoomToFitLayer]
  )
}
